import React from 'react'
import Breadcrumb from '../Breadcrumb/Breadcrumb'
import ClientsHome from './ClientsHome'
import clients from '../../asset/homefour/client.webp';
const Clients = () => {
  return (
    <div>
        <Breadcrumb bannerImage={clients} currentPage="Clients" />
        <ClientsHome />
    </div>
  )
}

export default Clients